var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProblem1 = function SvgProblem1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_1_svg__a)",
    fillRule: "evenodd",
    d: "M55.668 14.148c3.057 0 5.536-2.529 5.536-5.648 0-3.12-2.479-5.648-5.536-5.648S50.132 5.381 50.132 8.5c0 3.12 2.479 5.648 5.536 5.648M64 8.5c0 4.694-3.73 8.5-8.332 8.5s-8.332-3.806-8.332-8.5S51.066 0 55.668 0 64 3.806 64 8.5",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_1_svg__b)",
    fillRule: "evenodd",
    d: "M8.332 14.148c3.057 0 5.536-2.529 5.536-5.648 0-3.12-2.479-5.648-5.536-5.648S2.796 5.381 2.796 8.5c0 3.12 2.479 5.648 5.536 5.648M16.664 8.5c0 4.694-3.73 8.5-8.332 8.5S0 13.194 0 8.5 3.73 0 8.332 0s8.332 3.806 8.332 8.5",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_1_svg__c)",
    fillRule: "evenodd",
    d: "M15.266 4.507h33.468v7.986H15.266z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_1_svg__a",
    x1: -1.811,
    x2: 64,
    y1: 8.5,
    y2: 8.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_1_svg__b",
    x1: -1.811,
    x2: 64,
    y1: 8.5,
    y2: 8.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_1_svg__c",
    x1: -1.811,
    x2: 64,
    y1: 8.5,
    y2: 8.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })))));
};
export default SvgProblem1;